"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=SchoolIndex.js.map